// sns Event
import { WinSnsOpen, bindSNSEvent } from "./module/sns_event";

// Smooth Scroll
import smoothScrolling from "./module/smoothscroll";

// audio voice
import audioVoice from "./module/voice";

import switchBackground from "./module/switch_background";

(() => {
    smoothScrolling();

    document.addEventListener("DOMContentLoaded", () => {
        bindSNSEvent();
        audioVoice();

        // lightGallery
        //要素の有無を判定
        const isLightgallery = document.querySelector(".js-lightgallery") != null;
        if (isLightgallery) {
            lightGallery(document.querySelector("#worldGallery"), {
                selector: ".p-worldLists__link",
                // loop: true,
                licenseKey: "6FWDS-ANSLM-LFHZG-CLCTA",
                // plugins: [lgThumbnail, lgRotate],
                mobileSettings: { controls: true, showCloseIcon: true, download: false },
                download: false,
                share: false,
                flipHorizontal: false,
                flipVertical: false,
            });
        }

        switchBackground();
    });
})();
